import React from 'react';

import AboveTheFoldOnlyServerRender from '../../shared/components/above-the-fold-only-server-render';

import PDPNav from './sticky-nav';
import PDPDetails from './pdp-details';
import Offers from './pdp-details/above-the-fold-offers';
import PDPOverview from './pdp-overview';
import Features from './pdp-overview/exclusive-features';
import RichContent from './pdp-overview/pdp-rich-content';
import PDPSpecs from './pdp-specs';
import PDPOffers from './pdp-offers';
import Reviews from './reviews';
import PDPCrossSell from './cross-sell';
import PDPUpSell from './upsell';
import CompareDrawer from '../../compare/components/compare-drawer';
import CompatibleProducts from './compatible-products';
import ReturnsAndExchange from './return-exchange-info';
import TrackingPDPMetrics from './metrics/tracking-pdp-metrics';
import MobileAddToCart from './pdp-details/mobile-add-to-card';
import OOSPopup from './oos-popup';

import './pdp.less';

const PDP = () => {
    return (
        <>
            <TrackingPDPMetrics />
            <Offers showFor={['mobile']} className="pdp-mobile-offers" />
            <PDPDetails />
            <PDPNav />
            <PDPOverview />
            <AboveTheFoldOnlyServerRender skip={true}>
                <CompatibleProducts />
            </AboveTheFoldOnlyServerRender>
            <section id="recommendedAccessories">
                <AboveTheFoldOnlyServerRender skip={true} offset={1000}>
                    <PDPCrossSell />
                </AboveTheFoldOnlyServerRender>
            </section>
            <RichContent />
            <Features />
            <PDPSpecs />
            <section id="reviews">
                <AboveTheFoldOnlyServerRender skip={true} renderOn="idle" idleBuffer={1000}>
                    <Reviews />
                </AboveTheFoldOnlyServerRender>
            </section>
            <PDPOffers />
            <section id="similarProducts">
                <AboveTheFoldOnlyServerRender skip={true} offset={1000}>
                    <PDPUpSell />
                </AboveTheFoldOnlyServerRender>
            </section>
            <AboveTheFoldOnlyServerRender skip={true} renderOn="load">
                <ReturnsAndExchange />
            </AboveTheFoldOnlyServerRender>
            <AboveTheFoldOnlyServerRender skip={true} renderOn="load">
                <CompareDrawer
                    headerComp={(open, collapsed) => <MobileAddToCart offset={open ? (collapsed ? 49 : 413) : 0} />}
                />
            </AboveTheFoldOnlyServerRender>
            <AboveTheFoldOnlyServerRender skip={true} renderOn="load">
                <OOSPopup />
            </AboveTheFoldOnlyServerRender>
        </>
    );
};

export default PDP;
